<sbe-app-shell-root
  [infraError]="auth.infraError()"
  [showBootLoading]="showBootLoading()"
  [shellBare]="shellRouteData().shellBare"
  [header]="shellRouteData().shellMode"
  [navItems]="navItems()"
  [loggedIn]="auth.isAuthenticated()"
  title="학교종이"
  homeRoute="/"
  (retry)="retry()"
>
  <!--
    shellBare(팝업) 라우트에서는 이 슬롯 콘텐츠가 header='none' 셸에 아예 투영되지 않고
    버려지지만(AppShellComponent가 'none' 모드에서 shellToolbarEnd/Context 슬롯 자체를
    지원하지 않음), 컴포넌트 자신은 여전히 인스턴스화·변경감지된다 — app-account-menu가
    생성자에서 API 호출 등 부수효과를 갖게 되면 팝업을 열 때마다 불필요하게 실행된다
    (코드 리뷰 지적, 2026-08-11). shellBare가 아닐 때만 만든다.

    아래 두 @if는 일부러 서로 중첩하지 않고 나란히 뒀다(각각 독립적으로 shellBare/
    isLoggedIn을 재확인) — `@if (A) { @if (B) {...} @else {...} }`처럼 2단으로 중첩하면
    안쪽 분기에 있는 slot 투영 엘리먼트(shellToolbarEnd/Context 등)가 Angular 콘텐츠
    프로젝션에 전혀 잡히지 않는 버그를 실측했다(2026-08-17, 로그인 버튼이 프로덕션에서
    통째로 사라졌던 원인 — `@if (A && B) {...} @else if (A) {...}`처럼 단일 depth로
    펼치면 정상 투영된다).
  -->
  @if (!shellRouteData().shellBare && auth.isAuthenticated()) {
    <app-context-switcher
      shellToolbarContext
      [orgs]="orgContext.orgs()"
      [activeOrgId]="orgContext.selectedOrgId()"
      [teamsEnabled]="true"
      (orgSelected)="onOrgSelected($event)"
      (teamSelected)="onTeamSelected($event)"
      (createOrgRequested)="onCreateOrgRequested()"
    />
  }
  @if (sidebarTeamSelect(); as select) {
    <div shellSidenavHeader class="border-b border-gray-200 px-4 py-3 dark:border-gray-700">
      <!-- 팀 선택(트리 lib + 메뉴)은 초기 번들 예산을 넘기지 않게 지연 로드한다. -->
      @defer (on immediate) {
        <app-sidebar-context-select
          [teams]="select.teams"
          [orgName]="select.orgName"
          [orgSelectable]="select.orgSelectable"
          [selectedTeamId]="select.selectedTeamId"
          (teamSelected)="onSidebarContextSelected(select.orgId, $event)"
          (menuOpened)="onSidebarTeamsOpened()"
        />
      } @placeholder {
        <div class="h-8 w-full rounded border border-gray-200 dark:border-gray-700"></div>
      }
    </div>
  }
  @if (!shellRouteData().shellBare && auth.isAuthenticated()) {
    <app-account-menu shellToolbarEnd [userName]="userName()" (logoutRequested)="logout()" />
  } @else if (!shellRouteData().shellBare) {
    <a
      shellToolbarEnd
      mat-button
      routerLink="/login"
      class="!font-normal !text-gray-500 dark:!text-gray-400"
      >로그인</a
    >
  }
</sbe-app-shell-root>
